'use client';

import { useState } from 'react';
import { cn } from '@/lib/utils';

interface CoinImageProps {
  src?: string | null;
  alt: string;
  /** Short ticker/symbol used for the 2-letter text fallback */
  symbol?: string;
  className?: string;
}

export function CoinImage({ src, alt, symbol, className }: CoinImageProps) {
  const [failed, setFailed] = useState(false);
  const showPlaceholder = !src || failed;

  if (showPlaceholder) {
    const letters = (symbol || alt || '??').slice(0, 2).toUpperCase();
    return (
      <div
        className={cn(
          'w-full h-full flex items-center justify-center bg-muted border border-border/50 text-muted-foreground font-bold select-none',
          className,
        )}
      >
        <span className="text-[10px] leading-none">
          {letters}
        </span>
      </div>
    );
  }

  return (
    <div className={cn('w-full h-full relative overflow-hidden', className)}>
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${src})`,
          backgroundSize: '150%',
          backgroundPosition: 'center',
          filter: 'blur(8px) saturate(1.2)',
        }}
      />
      <img
        src={src}
        alt={alt}
        decoding="async"
        loading="lazy"
        className="w-full h-full object-cover relative"
        onLoad={(e) => {
          const img = e.currentTarget;
          if (img.naturalWidth <= 1 && img.naturalHeight <= 1) setFailed(true);
        }}
        onError={() => setFailed(true)}
      />
    </div>
  );
}
